/* global wp */
(function stich($) {
  class Material {
    constructor(material) {
      this.value = material.value;
      this.label = material.label;
      this.category = material.category;
      this.subcategory = material.subcategory;
      this.conversion = material.conversion;
      this.unitType = material.unit;
      this.total = material.total;
      this.sds = material.sds;
    }

    get unit() {
      return this.getUnit();
    }

    getUnit() {
      return `${this.unitType || 'kg'}${parseFloat(this.quantity) > 1 || parseFloat(this.quantity) < 1 ? 's' : ''}`;
    }

    get result() {
      return this.getResult();
    }

    getResult(quantity) {
      let total = '';

      if (!quantity || quantity === '0' || quantity === 0) return 0;

      if (this.total && !this.conversion) {
        total = (this.total * quantity).toFixed(3);
      } else if (this.total && this.conversion && this.unit) {
        total = (this.total * this.conversion * quantity).toFixed(3);
      }

      return total;
    }
  }

  class Search {
    constructor({ query, category, subcategory, material }) {
      this.query = query;
      this.category = category;
      this.subcategory = subcategory;
      this.material = material;
    }

    getSubcategories() {
      const dataObject = {
        action: 'action_materials_fetch_subcategories',
        category: this.category,
      };

      return new Promise((resolve, reject) => {
        jQuery.ajax({
          method: 'POST',
          url: wp.ajaxurl,
          data: dataObject,
        }).success((response) => resolve(JSON.parse(response))).error(reject);
      });
    }

    getMaterials() {
      const dataObject = {
        action: 'action_materials_fetch_materials',
        subcategory: this.subcategory
      };

      return new Promise((resolve, reject) => {
        jQuery.ajax({
          method: 'POST',
          url: wp.ajaxurl,
          data: dataObject,
        }).success((response)  => resolve(JSON.parse(response))).error(reject);
      });
    }

    getMaterial() {
      const dataObject = {
        action: 'action_materials_fetch_calculation',
        material: this.material
      };

      return new Promise((resolve, reject) => {
        jQuery.ajax({
          method: 'POST',
          url: wp.ajaxurl,
          data: dataObject,
        }).success((response) => resolve(new Material(JSON.parse(response)))).error(reject);
      });
    }

    getResults() {
      const dataObject = {
        action: 'action_materials_fetch_query',
        query: this.query
      };

      return new Promise((resolve, reject) => {
        jQuery.ajax({
          method: 'POST',
          url: wp.ajaxurl,
          data: dataObject,
        }).success((response) => {
          const results = JSON.parse(response);

          if (results.length) {
            const materials = results.map(result => new Material(result));
            resolve(materials);
          } else {
            reject(new Error('No Results'));
          }
        }).error(reject);
      });
    }
  }

  class Cart {
    constructor() {
      this.form = document.querySelector('#stich-form-cart');
      this.submit = document.querySelector('#stich-submit-cart');
      this.cart = document.querySelector('#stich-cart-items');
      this.empty = document.querySelector('#stich-cart-empty');
      this.total = document.querySelector('#stich-cart-total');
      this.searchResults = document.querySelector('#stich-results-search');

      this.items = {};

      if (this.form) this.form.addEventListener('submit', this.submitForm);
    }

    add = (item) => {
      this.items[item.value] = item;
      this.outputCart();
    }

    remove = (item) => {
      delete this.items[item.value];
      const result = this.searchResults.querySelector(`[data-material="${item.value}"]`);
      this.cart.querySelector(`tr[data-material="${item.value}"]`).remove();
      if (result) result.classList.remove('d-none');
      this.outputCart();
    }

    outputGraph = () => {
      new Graph(this.items);
    }

    outputTotal = () => {
      let total = 0;

      if (Object.keys(this.items).length) {
        Object.keys(this.items).map(itemValue => {
          const item = this.items[itemValue];
          const quantity = document.querySelector(`#quantity-${item.value}`);
          if (item.total) total += parseFloat(item.getResult(quantity.value));
        });
      }

      this.total.innerHTML = total.toFixed(3);
    }

    outputCart = () => {
      if (Object.keys(this.items).length) {
        Object.keys(this.items).map((itemValue, itemIndex) => {
          const exists = this.cart.querySelector(`tr[data-material="${this.items[itemValue].value}"]`);

          if (!exists) {
            const item = this.items[itemValue];
            const result = item.getResult(1);
            const tr = document.createElement('tr');
            tr.dataset.material = item.value;

            tr.innerHTML = `
              <td>${item.category.label}</td>
              <td>${item.subcategory ? item.subcategory.label : ''}</td>
              <td class="text-nowrap">${item.label}</td>
              <td class="text-nowrap"><input id="quantity-${item.value}" type="text" value="1" />&nbsp;${item.unit}</td>
              <td class="text-right">${item.total || 'Coming Soon'}</td>
              <td class="text-right" id="result-${item.value}">${result}</td>
              <td>${item.sds ? `<a href="${item.sds}" target="_blank">Safety Data Sheet</a>` : 'N/A'}</td>
              <td><button class="btn btn-danger btn-small" type="button">x</button></td>
            `;

            const button = tr.querySelector('.btn-danger');
            const input = tr.querySelector(`#quantity-${item.value}`);
            const output = tr.querySelector(`#result-${item.value}`);

            button.addEventListener('click', () => this.remove(item));
            input.addEventListener('change', () => {
              output.innerHTML = item.getResult(input.value);
              this.items[itemValue].quantity = input.value;
              this.outputTotal();
              this.outputGraph();
            });

            this.cart.append(tr);
          }
        });

        this.outputTotal();
        this.empty.classList.add('d-none');
        this.form.classList.remove('d-none');
      } else {
        this.form.classList.add('d-none');
        this.empty.classList.remove('d-none');
      }

      this.outputGraph();
    }

    submitForm = e => {
      e.preventDefault();
      console.log(this.items);
    }
  }

  class Graph {
    constructor(items = []) {
      this.wrapper = document.querySelector('#stich-cart-graph');
      this.list = document.querySelector('#stich-cart-graph .stich__graph--items');
      this.items = items;

      this.createTemplate();
    }

    getPercentageDiff = (total, item) => {
      const totalNum = total ? parseFloat(total) : 0;
      const totalItem = item ? parseFloat(item) : 0;

      const diff = 100 * (totalNum - totalItem) / ((totalNum + totalItem) / 2);
      const decrease = ((totalNum - totalItem) / totalNum) * 100;

      return decrease;
    }

    getTotals = () => {
      let totals = { base: 0, total: 0 };

      if (Object.keys(this.items).length) {
        totals = Object.keys(this.items).reduce((acc, obj) => {
          const total = this.items[obj].total ? parseFloat(this.items[obj].total) : 0;
          const quantity = this.items[obj].quantity ? parseFloat(this.items[obj].quantity) : 1;
          const result = this.items[obj].getResult(quantity) ? parseFloat(this.items[obj].getResult(quantity)) : 0;
          return { base: (parseFloat(acc.base) + total).toFixed(3), total: (parseFloat(acc.total) + result).toFixed(3) };
        }, totals);
      }

      return totals;
    }

    createTemplate = (id) => {
      this.list.innerHTML = '';
      this.wrapper.classList.add('d-none');

      if (Object.keys(this.items).length > 1 && Object.values(this.items).filter(item => item.total).length > 1) {
        const totals = this.getTotals();

        Object.keys(this.items).map(id => {
          const item = this.items[id];

          if (!item.total) return;

          const quantity = item.quantity ? parseFloat(item.quantity) : 1;
          /* const bar1 = this.getPercentageDiff(totals.base, item.total); */
          const bar2 = this.getPercentageDiff(totals.total, item.getResult(quantity));

          const html = `
            <li class="stich__graph--item">
              <div class="stich__graph--item--label">${item.label}</div>
              <div class="stich__graph--item--bars">
                <div class="stich__graph--item--total" style="width: ${100 - bar2}%">
                  <span>${item.getResult(quantity)}</span>
                </div>
              </div>
            </li>
          `;

          this.list.innerHTML = `${this.list.innerHTML}${html}`;
          this.wrapper.classList.remove('d-none');
        });
      }
    }
  }

  class Browse {
    constructor(cart) {
      this.cart  = cart;
      this.form = document.querySelector('[data-tab="browse"] #stich-form-browse');
      this.submit = document.querySelector('[data-tab="browse"] #stich-submit-browse');
      this.category = document.querySelector('[data-tab="browse"] #stich-category');
      this.subcategory = document.querySelector('[data-tab="browse"] #stich-subcategory');
      this.material = document.querySelector('[data-tab="browse"] #stich-material');
      this.results = document.querySelector('[data-tab="browse"] #stich-results-browse');

      if (this.form) this.form.addEventListener('submit', this.submitForm);
      if (this.category) this.category.addEventListener('change', this.handleCategory);
    }

    resetSelect = (select, html, disabled) => {
      select.innerHTML = html;
      select.value = '';
      select.disabled = disabled;
    }

    resetResults = () => {
      this.results.innerHTML = '';
      this.results.parentElement.classList.add('d-none');
      this.submit.disabled = true;
    }

    setLoading = () => {
      this.results.innerHTML = '<div class="alert alert-info" role="alert">Adding...</div>';
      this.results.parentElement.classList.remove('d-none');
    }

    submitForm = (e) => {
      e.preventDefault();
      this.setLoading();

      const search = new Search({ category: this.category.value, subcategory: this.subcategory.value, material: this.material.value });
      search.getMaterial().then((data) => {
        if (Object.keys(this.cart.items) && this.cart.items[data.value]) {
          this.results.innerHTML = '<div class="alert alert-warning" role="alert">Aleady Added</div>';
        } else {
          this.cart.add(data);
          this.results.innerHTML = '<div class="alert alert-success" role="alert">Added to Search</div>';
        }
      });
    }

    handleMaterial = () => {
      this.resetResults();

      if (this.material.value) {
        this.submit.disabled = false;
      }
    }

    handleSubcategory = () => {
      let html = '<option value="">Select an Item</option>';

      this.resetResults();
      this.resetSelect(this.material, '<option value="">Searching...</option>', true);

      if (this.subcategory.value) {
        const search = new Search({ category: this.category.value, subcategory: this.subcategory.value });
        search.getMaterials().then((data) => {
          if (data.length) {
            data.map(option => {
              html = `${html}<option value="${option.value}" data-unit="${option.unit}">${option.label}</option>`;
            });

            this.resetSelect(this.material, html, false);
            this.material.addEventListener('change', this.handleMaterial);
          } else {
            this.resetSelect(this.material, '<option value="">No Results</option>', true);
          }
        });
      } else {
        this.resetSelect(this.material, html, true);
      }
    }

    handleCategory = () => {
      let html = '<option value="">Select a Sub-Category</option>';

      this.resetResults();
      this.resetSelect(this.subcategory, '<option value="">Searching...</option>', true);

      if (this.category.value) {
        const search = new Search({ category: this.category.value });
        search.getSubcategories().then((data) => {
          if (data.length) {
            data.map(option => {
              html = `${html}<option value="${option.value}">${option.label}</option>`;
            });

            this.resetSelect(this.subcategory, html, false);
            this.subcategory.addEventListener('change', this.handleSubcategory);
          } else {
            this.resetSelect(this.subcategory, '<option value="">No Results</option>', true);
          }
        });
      } else {
        this.resetSelect(this.subcategory, html, true);
      }
    }
  }

  class Query {
    constructor(cart) {
      this.cart = cart;
      this.form = document.querySelector('[data-tab="search"] #stich-form-search');
      this.submit = document.querySelector('[data-tab="search"] #stich-submit-search');
      this.query = document.querySelector('[data-tab="search"] #stich-query');
      this.results = document.querySelector('[data-tab="search"] #stich-results-search');

      if (this.form) this.form.addEventListener('submit', this.submitForm);
    }

    setLoading = () => {
      this.results.innerHTML = '<div class="alert alert-info" role="alert">Searching...</div>';
      this.results.parentElement.classList.remove('d-none');
    }

    handleAdd = (material) => {
      this.cart.add(material);
      this.results.querySelector(`[data-material="${material.value}"]`).classList.add('d-none')
    }

    submitForm = (e) => {
      e.preventDefault();
      let html = '';
      this.setLoading();

      if (this.query.value && this.query.value.trim()) {
        const search = new Search({ query: this.query.value.trim() });
        search.getResults().then((data) => {
          if (data.length) {
            data.map((item, itemIndex) => {
              html = `
                ${html}
                <li data-material="${item.value}" class="${itemIndex < data.length - 1 ? '' : 'mb-2'}">
                  ${item.label}
                  <button data-index="${itemIndex}" class="btn btn-stich btn-small btn-outline" type="button">
                    Add <span>+</span>
                  </button>
                </li>`;
            });

            this.results.innerHTML = `<h4>Search Results</h4><ul class="list-unstyled mt-2">${html}</ul>`;
            const links = Array.from(this.results.querySelectorAll('li button'));
            links.map(link => link.addEventListener('click', () => this.handleAdd(data[link.dataset.index], link)));
          } else {
            this.results.innerHTML = '<div class="alert alert-danger" role="alert">No Results</div>';
          }
        }).catch(error => {
          this.results.innerHTML = `<div class="alert alert-danger" role="alert">${error.message}</div>`;
        });
      } else {
        this.results.innerHTML = '<div class="alert alert-warning" role="alert">Please Enter a Search Term</div>';
      }
    }
  }

  class Navigation {
    constructor() {
      this.links = Array.from(document.querySelectorAll('#stich-navigation .btn'));
      this.tabs = Array.from(document.querySelectorAll('#stich-tool .stich__main [data-tab]'));
      this.default = window.location.hash ? window.location.hash.replace('#', '') : 'browse';

      if (this.links.length) {
        this.links.map(link => {
          link.addEventListener('click', () => this.handleTabClick(link));
          if (link.dataset.ref === this.default) link.click();
        });
      }
    }

    handleTabClick = (link) => {
      this.links.map(nav => nav.classList.remove('active'));
      link.classList.add('active');
      history.pushState(null, null, `#${link.dataset.ref}`);
      this.handleTabSwitch(link.dataset.ref);
    }

    handleTabSwitch = (active) => {
      const current = document.querySelector(`#stich-tool [data-tab="${active}"]`);

      if (current) {
        this.tabs.map(tab => tab.classList.add('d-none'));
        current.classList.remove('d-none');
      }
    }
  }

  const cart = new Cart();
  new Browse(cart);
  new Query(cart);
  new Navigation();
}(jQuery));
